import type { AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from "axios";
import axios from "axios";
import { ElMessage, ElLoading, ElMessageBox } from "element-plus";
export interface RequestInterceptors<T = AxiosResponse> {
  requestInterceptor?: (config: AxiosRequestConfig) => AxiosRequestConfig;
  requestInterceptorCatch?: (error: unknown) => unknown;
  responseInterceptor?: (res: T) => T;
  responseInterceptorCatch?: (error: unknown) => unknown;
}
// axios.defaults.baseURL = "http://127.0.0.1:3001/api/";
export interface RequestConfig<T = AxiosResponse> extends AxiosRequestConfig {
  interceptors?: RequestInterceptors<T>;
  showLoading?: boolean;
  showErrorToast?: boolean;
  needAuth?: boolean;
}
const DEFAULT_LOADING = true;
const DEFAULT_ERROR_TOAST = true;
// const DEFAULT_NEED_AUTH = true;

class Request {
  instance: AxiosInstance;
  interceptors?: RequestInterceptors;
  showLoading: boolean;
  showErrorToast: boolean;
  // needAuth: boolean;

  constructor(config: RequestConfig) {
    // 创建axios实例
    this.instance = axios.create(config);

    // 保存基本信息
    this.showLoading = config.showLoading ?? DEFAULT_LOADING;
    this.showErrorToast = config.showErrorToast ?? DEFAULT_ERROR_TOAST;
    // this.needAuth = config.needAuth ?? DEFAULT_NEED_AUTH;
    this.interceptors = config.interceptors;

    // 使用拦截器
    // 1.从config中取出的拦截器是对应的实例的拦截器
    this.instance.interceptors.request.use(this.interceptors?.requestInterceptor, this.interceptors?.requestInterceptorCatch);
    this.instance.interceptors.response.use(this.interceptors?.responseInterceptor, this.interceptors?.responseInterceptorCatch);

    // 2.添加所有的实例都有的拦截器
    this.instance.interceptors.request.use(
      (config) => {
        if (this.showLoading) {
          // const loading = ElLoading.service({
          //   lock: true,
          //   text: "Loading",
          //   background: "rgba(0, 0, 0, 0.7)",
          // });
          // loading;
        }
        if (localStorage.getItem("token")) {
          (config.headers as AxiosRequestHeaders)["ACCESS_TOKEN"] = localStorage.getItem("token") as string;
        }
        return config;
      },
      (err) => {
        return err;
      }
    );

    this.instance.interceptors.response.use(
      (response) => {
        // const loading = ElLoading.service({
        //   lock: true,
        //   text: "Loading",
        //   background: "rgba(0, 0, 0, 0.7)",
        // });
        // loading.close();
        const code = response?.status;
        // 请求成功
        if (code === 200) {
          if (response?.data?.code === 0) {
            ElMessage({
              message: response?.data?.msg,
              type: "error",
            });
            return Promise.reject(response?.data || {});
          }
          // if (response?.data?.code === 1) {
          //   ElMessage({
          //     message: response?.data?.msg,
          //     type: "success",
          //   });
          //   return Promise.reject(response?.data || {});
          // }
          if (response?.data?.code === 401) {
            ElMessage({
              message: response?.data?.msg,
              type: "warning",
            });
            setTimeout(() => {
              localStorage.removeItem("userInfo");
              localStorage.removeItem("token");
              window.location.href = "/login";
            }, 1000);
            return Promise.reject(response?.data || {});
          }
          return Promise.resolve(response.data);
        } else {
          ElMessage({
            message: response?.data?.msg,
            type: "warning",
          });
          return Promise.reject(response.data);
        }
      },
      (error) => {
        if (!error.response) {
          ElMessageBox.alert(error.message, "错误提示", {
            type: "error",
          });
        }
        if (error.code === "ECONNABORTED") {
          ElMessageBox.alert("数据请求超时，请重新请求", "错误提示", {
            type: "error",
          });
        } else {
          if (error.response.status === 401) {
            window.location.href = "/login";
          } else if (error.response.status === 400) {
            ElMessageBox.alert(error.response.data, "错误提示", {
              type: "error",
            });
          } else {
            ElMessageBox.alert(error.response.status + "服务繁忙", "错误提示", {
              type: "error",
            });
            console.log(error.response.data);
          }
        }
        return Promise.reject(error);
      }
    );
  }

  request<T>(config: RequestConfig<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      // 1.单个请求对请求config的处理
      if (config.interceptors?.requestInterceptor) {
        config = config.interceptors.requestInterceptor(config);
      }

      this.instance
        .request<unknown, T>(config)
        .then((res) => {
          // 1.单个请求对数据的处理
          if (config.interceptors?.responseInterceptor) {
            res = config.interceptors.responseInterceptor(res);
          }
          // 2.将showLoading设置true, 这样不会影响下一个请求
          this.showLoading = DEFAULT_LOADING;
          this.showErrorToast = DEFAULT_ERROR_TOAST;
          // this.needAuth = DEFAULT_NEED_AUTH;

          // 3.将结果resolve返回出去
          resolve(res);
        })
        .catch((err) => {
          // 将showLoading设置true, 这样不会影响下一个请求
          this.showLoading = DEFAULT_LOADING;
          this.showErrorToast = DEFAULT_ERROR_TOAST;
          // this.needAuth = DEFAULT_NEED_AUTH;
          reject(err);
          return err;
        });
    });
  }

  get<T>(config: RequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "GET" });
  }

  post<T>(config: RequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "POST" });
  }

  delete<T>(config: RequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "DELETE" });
  }

  put<T>(config: RequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "PUT" });
  }
}
// 所有可能用到的接口
const environments = {
  development: {
    // 本地环境
    baseURL: "http://platapi.9000ji.net",
    UploadUrl: "http://upload.9000ji.net/upload", //上传测试接口
    batchUrl: "http://upload.9000ji.net/multiUpload", //批量接口
  },
  testing: {
    // 测试环境
    baseURL: "http://platapi.9000ji.net",
    UploadUrl: "http://upload.9000ji.net/upload", //上传测试接口
    batchUrl: "http://upload.9000ji.net/multiUpload", //批量接口
  },
  release: {
    // 预发布0
    baseURL: "http://platapi.fanxinghuishou.cn",
    UploadUrl: "http://upload.fanxinghuishou.cn/upload", //上传测试接口
    batchUrl: "http://upload.fanxinghuishou.cn/multiUpload", //批量接口
  },
  production: {
    // 生产环境
    baseURL: "https://platapi.fanxinghuishou.com",
    UploadUrl: "https://upload.fanxinghuishou.com/upload", //上传测试接口
    batchUrl: "https://upload.fanxinghuishou.com/multiUpload", //批量接口
  },
} as any;
console.log(process.env);

const http = new Request({
  timeout: 30000,
  showLoading: true,
  showErrorToast: true,
  baseURL: environments[process.env.NODE_ENV as any].baseURL,
});
export const UploadUrl = environments[process.env.NODE_ENV as any].UploadUrl; //上传测试接口
export const batchUrl = environments[process.env.NODE_ENV as any].batchUrl; //批量接口
export default http;
